@charset "UTF-8";
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Render the `main` element consistently in IE.
 */
main {
  display: block;
}

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

:host {
  position: relative;
  outline: none;
  display: block;
  margin-bottom: var(--spacing-lay-s);
  font-family: "Times New Roman", Times, serif;
}
:host:last-child {
  margin-bottom: 0;
}
:host .item__header__button {
  display: flex;
  align-items: center;
  border-width: var(--border-width-md);
  border-style: solid;
  border-color: transparent;
}
:host .item__header__button:focus {
  outline: none;
  border-color: var(--color-primary-active);
}
:host .item__header__button__title-subtitle__title {
  margin: 0;
}
:host .item__header__button__title-subtitle__subtitle {
  margin: 0;
}
:host .item__header__button__meta-icon-wrapper__icon {
  display: flex;
}
:host .item__header__button:hover {
  cursor: pointer;
}
:host .item__container {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  text-align: start;
}
:host .disabled-layer {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  cursor: not-allowed;
}

:host([mode=classical]) .item__header__button,
:host([mode=boxed]) .item__header__button {
  justify-content: space-between;
  padding-top: 0;
  padding-inline-end: var(--spacing-comp-01);
  padding-bottom: 0;
  padding-inline-start: var(--spacing-comp-02);
  min-height: 20px;
  transition-property: background-color;
  transition-duration: var(--ui-animaton-speed);
  transition-timing-function: ease;
}
:host([mode=classical]) .item__header__button .cover ,
:host([mode=boxed]) .item__header__button .cover  {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background-color: transparent;
  z-index: 10;
}
:host([mode=classical]) .item__header__button .cover.hidden,
:host([mode=boxed]) .item__header__button .cover.hidden {
  display: none;
}
:host([mode=classical]) .item__header__button__title-subtitle,
:host([mode=boxed]) .item__header__button__title-subtitle {
  margin-inline-end: var(--spacing-comp-04);
  width: 100%;
}
:host([mode=classical]) .item__header__button__title-subtitle__title,
:host([mode=boxed]) .item__header__button__title-subtitle__title {
  display: flex;
  align-items: center;
  text-align: start;
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  letter-spacing: 0.06em;
}
:host([mode=classical]) .item__header__button__title-subtitle__title gxg-form-text::part(input),
:host([mode=boxed]) .item__header__button__title-subtitle__title gxg-form-text::part(input) {
  letter-spacing: 0.06em;
}
:host([mode=classical]) .item__header__button__title-subtitle__title__icon,
:host([mode=boxed]) .item__header__button__title-subtitle__title__icon {
  display: flex;
  margin-inline-end: var(--spacing-comp-01);
}
:host([mode=classical]) .item__header__button__title-subtitle__subtitle,
:host([mode=boxed]) .item__header__button__title-subtitle__subtitle {
  padding-bottom: 2px;
  max-width: 300px;
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  text-align: start;
}
:host([mode=classical]) .item__header__button__meta-icon-wrapper,
:host([mode=boxed]) .item__header__button__meta-icon-wrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
:host([mode=classical]) .item__header__button__meta-icon-wrapper__meta,
:host([mode=boxed]) .item__header__button__meta-icon-wrapper__meta {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  display: flex;
  margin-right: var(--spacing-comp-02);
}
:host([mode=classical]) .item__container,
:host([mode=boxed]) .item__container {
  padding-top: var(--spacing-comp-02);
  padding-inline-end: var(--spacing-comp-02);
  padding-bottom: var(--spacing-comp-02);
  padding-inline-start: var(--spacing-comp-02);
}

:host([mode=classical].has-subtitle) .item__header__button,
:host([mode=boxed].has-subtitle) .item__header__button {
  align-items: start;
}

:host([mode=classical][no-padding]) .item__container,
:host([mode=boxed][no-padding]) .item__container {
  padding: 0;
}

:host([mode=classical][has-border]) .item__container {
  border: var(--border-width-sm) solid var(--gray-02);
  border-top: 0;
}

:host([mode=classical]) .item__header__button {
  background-color: var(--color-secondary-enabled);
}
:host([mode=classical]) .item__header__button:hover {
  background-color: var(--color-secondary-hover);
}
:host([mode=classical]) .item__container {
  background-color: var(--color-background);
}
:host([mode=classical]) .item--disabled {
  cursor: not-allowed;
}
:host([mode=classical]) .item--disabled .item__header__button {
  background-color: var(--color-primary-disabled);
}
:host([mode=classical]) .item--disabled .item__header__button .icon-wrapper {
  padding-inline-end: 2px;
}
:host([mode=classical]) .item--disabled .item__header__button__title-subtitle__title, :host([mode=classical]) .item--disabled .item__header__button__title-subtitle__subtitle {
  color: var(--color-on-disabled);
}
:host([mode=classical]) .item--disabled .item__header__button__meta-icon-wrapper__meta {
  color: var(--color-on-primary);
  opacity: 0.3;
}

:host([mode=classical][editable-title]) .item__header__button__title-subtitle__subtitle {
  margin-inline-start: 5px;
}
:host([mode=classical][editable-title]) .item--disabled .item__header__button__title-subtitle__title {
  opacity: 0.3;
}

:host([mode=boxed]) .item {
  background-color: var(--gray-01);
  transition-property: border-color;
  transition-duration: var(--ui-animaton-speed);
  transition-timing-function: ease;
}
:host([mode=boxed]) .item__header__button {
  background: transparent;
}
:host([mode=boxed]) .item__header__button:hover {
  background-color: var(--gray-02);
}
:host([mode=boxed]) .item__container {
  background: transparent;
}
:host([mode=boxed]) .item:hover {
  border-color: var(--color-primary-hover);
}
:host([mode=boxed]) .item--disabled .item__header__button__title-subtitle__title, :host([mode=boxed]) .item--disabled .item__header__button__title-subtitle__subtitle {
  color: var(--color-primary-disabled);
}
:host([mode=boxed]) .item--disabled .item__header__button__meta-icon-wrapper__meta {
  opacity: 0.5;
}

:host([mode=boxed][editable-title]) .item__header__button__title-subtitle__subtitle {
  margin-inline-start: 5px;
}
:host([mode=boxed][editable-title]) .item--disabled .item__header__button__title-subtitle__title {
  opacity: 0.5;
}

:host([mode=slim]) .item__header__button,
:host([mode=minimal]) .item__header__button {
  justify-content: flex-end;
  flex-direction: row-reverse;
}
:host([mode=slim]) .item__container,
:host([mode=minimal]) .item__container {
  padding-top: var(--spacing-comp-01);
  padding-inline-end: 0;
  padding-bottom: var(--spacing-comp-01);
  padding-inline-start: 0;
}

:host([mode=slim][no-padding]) .item__container,
:host([mode=minimal][no-padding]) .item__container {
  padding: 0;
  margin-inline-start: 0;
}

:host([mode=slim]) {
  margin-bottom: var(--spacing-lay-xs);
}
:host([mode=slim]) .item__header__button {
  padding: 2px 0;
}
:host([mode=slim]) .item__header__button:hover gxg-icon {
  background-color: var(--color-primary-hover);
}
:host([mode=slim]) .item__header__button:active gxg-icon {
  background-color: var(--color-primary-active);
}
:host([mode=slim]) .item__header__button gxg-icon {
  background: var(--color-primary-enabled);
  border-radius: 50%;
  margin-inline-end: var(--spacing-comp-02);
  width: 16px;
  height: 16px;
}
:host([mode=slim]) .item__header__button__title-subtitle__title {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}
:host([mode=slim]) .item__container {
  margin-inline-start: 26px;
}
:host([mode=slim]) .item--open gxg-icon {
  background: var(--color-primary-active);
}
:host([mode=slim]) .item--disabled {
  cursor: not-allowed;
  pointer-events: none;
}
:host([mode=slim]) .item--disabled gxg-icon {
  background: var(--color-primary-disabled);
}

:host([mode=minimal]) {
  margin-bottom: var(--spacing-lay-xs);
}
:host([mode=minimal]) .item__header__button gxg-icon {
  margin-inline-end: var(--spacing-comp-01);
}
:host([mode=minimal]) .item__header__button__title-subtitle__title {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}
:host([mode=minimal]) .item__container {
  margin-inline-start: 26px;
}

/*********************************************
LARGE VERSION (html tag has 'gxg-large' class)
**********************************************/
:host([mode=classical].large) .item__header__button__title-subtitle__title,
:host([mode=boxed].large) .item__header__button__title-subtitle__title {
  font-size: var(--font-size-lg);
}
:host([mode=classical].large) .item__header__button__title-subtitle__subtitle,
:host([mode=boxed].large) .item__header__button__title-subtitle__subtitle {
  font-size: var(--font-size-lg);
}
:host([mode=classical].large) .item__header__button__meta-icon-wrapper__meta,
:host([mode=boxed].large) .item__header__button__meta-icon-wrapper__meta {
  font-size: var(--font-size-lg);
}
:host([mode=classical].large) .item__container,
:host([mode=boxed].large) .item__container {
  font-size: var(--font-size-lg);
}

:host([mode=slim].large) .item__header__button__title-subtitle__title {
  font-size: var(--font-size-lg);
}
:host([mode=slim].large) .item__container {
  font-size: var(--font-size-lg);
}

:host([mode=minimal].large) .item__header__button__title-subtitle__title {
  font-size: var(--font-size-lg);
}
:host([mode=minimal].large) .item__container {
  font-size: var(--font-size-lg);
}